import script from "./KDiscountCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./KDiscountCard.vue?vue&type=script&setup=true&lang=ts"

import "./KDiscountCard.vue?vue&type=style&index=0&id=020f80be&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-020f80be"]])

export default __exports__